import { render, staticRenderFns } from "./pending_settlements.vue?vue&type=template&id=2a065666&"
import script from "./pending_settlements.vue?vue&type=script&lang=js&"
export * from "./pending_settlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports